var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossSlim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4 4.9l.7.7L5.6 16.1l-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 15.401l-.7.7-10.5-10.5.7-.7z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0iIzAwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGc+CjxyZWN0IHg9IjE1LjQwMDQiIHk9IjQuOTAwMzYiIHdpZHRoPSIwLjk4OTk0OSIgaGVpZ2h0PSIxNC44NDkyIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxNS40MDA0IDQuOTAwMzYpIiBmaWxsPSJpbmhlcml0Ii8+CjxyZWN0IHg9IjE2LjA5OTYiIHk9IjE1LjQwMDQiIHdpZHRoPSIwLjk4OTk0OSIgaGVpZ2h0PSIxNC44NDkyIiB0cmFuc2Zvcm09InJvdGF0ZSgxMzUgMTYuMDk5NiAxNS40MDA0KSIgZmlsbD0iaW5oZXJpdCIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgCrossSlim as ReactComponent };